export default __webpack_public_path__ + "static/media/59.654dec04.png";